import { normalizeWeightClassForLevel } from "./competitionFederationConfig";

export const buildClientCompetitionSnapshotUpdate = ({
  competition,
  selectedWeightClass,
  clientGender,
}) => {
  const normalizedWeightClass = normalizeWeightClassForLevel(
    selectedWeightClass,
    competition?.competitionLevel,
    clientGender
  );

  return {
    name: competition?.name ?? "",
    competitionClass: competition?.competitionClass ?? "",
    competitionLevel: competition?.competitionLevel ?? "",
    date: competition?.date ?? new Date(),
    weightClass: normalizedWeightClass,
  };
};
